/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { PagedAsyncIterableIterator } from "@azure/core-paging";
import {
  GallerySoftDeletedResource,
  SoftDeletedResourceListByArtifactNameOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a SoftDeletedResource. */
export interface SoftDeletedResource {
  /**
   * List soft-deleted resources of an artifact in the gallery, such as soft-deleted gallery image
   * version of an image.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param galleryName The name of the Shared Image Gallery.
   * @param artifactType The type of the artifact to be listed, such as gallery image version.
   * @param artifactName The artifact name to be listed. If artifact type is Images, then the artifact
   *                     name should be the gallery image name.
   * @param options The options parameters.
   */
  listByArtifactName(
    resourceGroupName: string,
    galleryName: string,
    artifactType: string,
    artifactName: string,
    options?: SoftDeletedResourceListByArtifactNameOptionalParams,
  ): PagedAsyncIterableIterator<GallerySoftDeletedResource>;
}
